import cx from 'classnames';
import PropTypes from 'prop-types';
import decorations from './images';
import { Image } from 'semantic-ui-react';

const Body = ({ data, isEditMode }) => {
  const { vertical, horizontal, image } = data;

  const verticalOffset = { top: `${vertical || 0}px` };

  const classes = cx('block-decoration', horizontal, {
    isEditMode,
    'full-width': !isEditMode,
  });

  return (
    <div className={classes}>
      <Image
        src={decorations[image]}
        style={verticalOffset}
        alt=""
        aria-hidden="true"
      />
    </div>
  );
};

Body.propTypes = {
  data: PropTypes.shape({
    vertical: PropTypes.number,
    horizontal: PropTypes.string,
    image: PropTypes.string,
  }),
  isEditMode: PropTypes.bool,
};

export default Body;
